import * as $runtime from "../runtime.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Network$dJsonRPC from "../Network.JsonRPC/index.js";
import * as Restaumatic$dGeocoding$dRPC$dSites$dTypes from "../Restaumatic.Geocoding.RPC.Sites.Types/index.js";
import * as Restaumatic$dSite$dRPC from "../Restaumatic.Site.RPC/index.js";
import * as Utils$dDataLoading from "../Utils.DataLoading/index.js";
const sitesRPC = /* #__PURE__ */ Restaumatic$dSite$dRPC.sitesRPC(/* #__PURE__ */ Network$dJsonRPC.encodeRequest(Restaumatic$dGeocoding$dRPC$dSites$dTypes.encodeGeocodeRequest)({
  encodeWithOptions: v => Restaumatic$dGeocoding$dRPC$dSites$dTypes.encodeGeocodeRequest.encode
}))(/* #__PURE__ */ Network$dJsonRPC.decodeResponse(Restaumatic$dGeocoding$dRPC$dSites$dTypes.decodeGeocodeResponse))(Restaumatic$dGeocoding$dRPC$dSites$dTypes.rPCMethodNameGeocodeReque);
const geocodeAddress = accountId => restaurantId => fromPS => country => address => Effect$dAff._map(x => {
  if (x.tag === "Left") { return Data$dEither.$Either("Left", Utils$dDataLoading.NetworkError); }
  if (x.tag === "Right") {
    return Data$dEither.$Either(
      "Right",
      {location: x._1.coordinates.tag === "Just" ? Data$dMaybe.$Maybe("Just", {latitude: x._1.coordinates._1.lat, longitude: x._1.coordinates._1.lon}) : Data$dMaybe.Nothing}
    );
  }
  $runtime.fail();
})(sitesRPC({country, streetAddress: address, fromPS: Data$dMaybe.$Maybe("Just", fromPS), restaurantId, accountId}));
const higgsGeocoding = accountId => restaurantId => fromPS => ({geocodeAddress: geocodeAddress(accountId)(restaurantId)(fromPS)});
export {geocodeAddress, higgsGeocoding, sitesRPC};
